export function addCumulativePriority(
  priorities: Map<string, number>,
  id: string,
  priority: number,
  apply: (id: string, priority: number) => void
): () => void {
  const nextPriority = (priorities.get(id) ?? 0) + priority;
  priorities.set(id, nextPriority);
  apply(id, nextPriority);

  let active = true;
  return () => {
    if (!active) return;
    active = false;

    const remainingPriority = (priorities.get(id) ?? 0) - priority;
    if (remainingPriority === 0) {
      priorities.delete(id);
    } else {
      priorities.set(id, remainingPriority);
    }
    apply(id, remainingPriority);
  };
}
